"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterEntitiesByExtensions = void 0;
// this function is needed for https://jira.autodesk.com/browse/SCCOM-13124
/**
 * Returns a new filtered array of files for the EntityPickerModal. Files will be filtered out if they have a file extension that is included in extensionsToFilter.
 * @param entities The files array.
 * @param extensionsToFilter an array of file extensions that should  be filtered out from the entities array.
 */
const filterEntitiesByExtensions = (entities, extensionsToFilter) => {
  return entities.filter(entity => {
    if (!entity) {
      return true;
    }
    const {
      title
    } = entity;
    if (!title) {
      return true;
    }
    if (entity.children) {
      entity.children = filterEntitiesByExtensions(entity.children, extensionsToFilter);
    }
    const fileExtensionDelimiter = ".";
    const isFile = title.includes(fileExtensionDelimiter);
    if (!isFile) {
      return true;
    }
    const fileExtension = title.split(".").pop();
    return !extensionsToFilter.includes(fileExtension);
  });
};
exports.filterEntitiesByExtensions = filterEntitiesByExtensions;
//# sourceMappingURL=filterEntitiesByExtensions.js.map